import React from "react";
import HeroSection from "./Home/HeroSection";
import FeaturesSection from "./Home/FeaturesSection";
import PurposeSection from "./Home/PurposeSection";
import CounterSection from "./Home/CounterSection";
import ContactSection from './Home/ContactSection';
import ServicesSection from "./Home/ServiceSection";
import PrintGallerySection from "./Home/PrintGallerySection";
import ReviewSection from "./Home/ReviewSection";
import ClientRateSection from "./Home/ClientRateSection";
import BlogSection from "./Home/BlogSection";

const Home = () => {
  return (
    <>
      <HeroSection />

      <FeaturesSection />

      <PurposeSection />

      <CounterSection />

      <ServicesSection />

      <ContactSection />

      <PrintGallerySection />

      <ReviewSection />

      <ClientRateSection />

      <BlogSection />
    </>
  );
};

export default Home;